// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 500) return "static/chunks/500-365752e766f68420.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "e97853cef5fb5560" + ".js";
};